/** @jsxImportSource @emotion/react */
import { appConfig } from '../../../../../constants';
import React from 'react';
import { Typography, Link } from '@mui/material';
import moment from 'moment';
import { useStyles } from './Footer.styles';

export function Footer(): React.ReactElement {
  const { version } = appConfig;
  const styles = useStyles();

  return (
    <div css={styles}>
      <div className="title-container">
        <Typography variant="body1">
          &copy;{' '}
          <Link component="a" href="/" target="_blank">
            Gaytaro
          </Link>
          . {moment().year()}
        </Typography>

        <Typography variant="body1">v{version}</Typography>
      </div>
    </div>
  );
}
